import * as React from "react";
type Props = {
  className?: string,
};
function SvgSpendMoreSaveMore({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-testid="illustrated-Spend More Save More"
      className={className}
    >
      <title>{"BuyMoreSaveMore_V2"}</title>
      <g
        id="BuyMoreSaveMore_V2"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-2" transform="translate(-0.200000, 1.000000)">
          <g id="Group-9" transform="translate(1.000000, 1.000000)" />
          <g
            id="Group-6"
            transform="translate(0.320000, 0.232000)"
            stroke="currentColor"
            strokeWidth={1.35}
          >
            <path
              d="M10.1552664,1.11079154 C11.0644344,0.622823537 11.6460024,0.698327537 12.1976184,1.07085554 C13.0843224,1.66989554 13.9797624,1.28426354 13.8674424,1.48706354 C13.0325304,2.90853554 12.1732824,4.52656754 11.3389944,5.94741554 C11.0072661,6.0621787 16.2540478,9.8287292 17.1483805,14.5615254 L38.8766312,14.5616516 L38.8766312,35.9179118 L9.06400252,35.9179118 L9.07564724,23.6761651 C8.73816451,23.6783929 0.972916531,23.6454799 0.683570444,15.9033355 C0.505730444,11.1609355 7.03214644,5.87440754 6.67958644,5.92495154 C6.67958644,5.92495154 3.67627444,1.37349554 3.99576244,1.35103154 C4.23849844,1.33418354 5.20133044,1.82464754 6.14793844,1.24495154 C7.07582644,0.676487537 7.75848244,0.777575537 8.21899444,1.05712754 C9.01022644,1.53698354 9.32035444,1.55882354 10.1552664,1.11079154 Z"
              id="Combined-Shape"
            />
            <path
              d="M10.1552664,1.11079154 C11.0644344,0.622823537 11.6460024,0.698327537 12.1976184,1.07085554 C13.0843224,1.66989554 13.9797624,1.28426354 13.8674424,1.48706354 C13.0325304,2.90853554 12.1732824,4.52656754 11.3389944,5.94741554 C11.067375,6.04138371 14.5357831,8.58363738 16.2925926,12.0999414 L16.6098153,12 L31.2500399,12 L38.8824112,14.5248572 L31.3085444,12.061324 L16.6309615,12.061324 L16.3203183,12.1558056 C16.8931057,13.3176737 17.2769784,14.5844239 17.2769784,15.9033355 C17.2769784,19.9774315 14.2393464,23.5148875 9.08697844,23.6760487 C9.08697844,23.6760487 0.979346444,23.8175275 0.683570444,15.9033355 C0.505730444,11.1609355 7.03214644,5.87440754 6.67958644,5.92495154 C6.67958644,5.92495154 3.67627444,1.37349554 3.99576244,1.35103154 C4.23849844,1.33418354 5.20133044,1.82464754 6.14793844,1.24495154 C7.07582644,0.676487537 7.75848244,0.777575537 8.21899444,1.05712754 C9.01022644,1.53698354 9.32035444,1.55882354 10.1552664,1.11079154 Z"
              id="Combined-Shape"
            />
            <path
              d="M18.8940992,30.1437988 C19.296582,27.4180526 21.6980863,25.4479309 24.3420672,25.5705789 C26.8091248,25.6854733 28.9195163,27.5963856 29.2930993,30.1318159 L34.0185719,30.1318159 C33.9685259,29.7251039 33.176248,24.0734274 28.2174622,21.7677858 C25.2210446,20.3742507 22.4234013,20.9797372 21.6614329,21.1728725 C18.2364521,22.0426865 15.7524776,24.6655212 14.7290011,27.4476573 C14.3385011,28.5063774 14.2095093,29.4558421 14.166512,30.1332257 C15.7426093,30.13675 17.3180018,30.1402744 18.8940992,30.1437988 Z"
              id="Stroke-4"
            />
          </g>
          <g id="Group-32" transform="translate(9.320000, 1.000000)">
            <g id="Group-31" transform="translate(0.664024, 0.294552)" />
          </g>
          <g
            id="Group"
            transform="translate(7.000000, 6.000000)"
            stroke="currentColor"
          >
            <path
              d="M4.66897844,7.48938834 C4.62904244,7.37394834 4.42873844,6.30254034 3.10149044,5.96121234 C3.01849844,5.93999634 1.73992244,5.58057234 0.891282444,6.46166034 C0.830130444,6.52530834 0.0800824441,7.33026834 0.385842444,8.29871634 C0.625458444,9.05874834 1.30936244,9.52487634 2.31462644,9.56481234 C2.77451444,9.62034834 3.07091444,9.47495634 3.65061044,9.71956434 C4.29270644,9.99100434 4.59659444,10.5376283 4.71328244,11.2246523 C4.89798644,12.3129083 3.94451444,12.9887003 3.74920244,13.0904123 C2.72833844,13.6233083 0.997986444,13.4585723 0.163698444,11.9728283"
              id="Stroke-3"
              strokeWidth={1.404}
            />
            <line
              x1={2.56048244}
              y1={4.54073874}
              x2={2.25472244}
              y2={14.7868187}
              id="Stroke-5"
              strokeWidth={1.404}
            />
            <line
              x1={2.56048244}
              y1={4.54073874}
              x2={2.25472244}
              y2={14.7868187}
              id="Stroke-5"
              strokeWidth={1.35}
            />
            <path
              d="M-0.00060075587,0.156701937 C-0.00060075587,0.156701937 1.58311124,1.05026994 4.65880724,0.156701937"
              id="Stroke-7"
              strokeWidth={1.35}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
export default SvgSpendMoreSaveMore;
